import axios from "axios";
import Config from "../Config";
import ErrorMessage from "../libs/helpers/ErrorMessage";
import { buildAxiosConfig } from "./utils";

const wrap = async (call) => {
  try {
    const res = await call();
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status: httpStatus } = e.response;
      const { httpStatus: hs, clientType, description } = e.response.data || {};
      throw new ErrorMessage(
        statusText,
        description,
        hs,
        httpStatus,
        clientType,
      );
    } else throw e;
  }
};

// Latest KPI snapshot, latest AI accuracy run and their history, for the current tenant.
export const getDataQualityApi = () =>
  wrap(() =>
    axios.get(`${Config.apiBaseurl}/api/v1/data-quality`, buildAxiosConfig()),
  );

// Computes a fresh snapshot in the background. type: "kpis" | "accuracy".
export const startDataQualityRunApi = (type) =>
  wrap(() =>
    axios.post(
      `${Config.apiBaseurl}/api/v1/data-quality/run`,
      { type },
      buildAxiosConfig(),
    ),
  );

// The latest AI check of one record (entity: "company" | "contact" | "brand"), null if none or
// archived.
export const getAiVerificationApi = ({ entity, id }) =>
  wrap(() =>
    axios.get(`${Config.apiBaseurl}/api/v1/data-quality/verification`, {
      ...buildAxiosConfig(),
      params: { entity, id },
    }),
  );

// Has the AI check a record now (a few seconds) and answers with the result.
export const verifyWithAiApi = ({ entity, id }) =>
  wrap(() =>
    axios.post(
      `${Config.apiBaseurl}/api/v1/data-quality/verify`,
      { entity, id },
      buildAxiosConfig(),
    ),
  );

export const archiveAiVerificationApi = (verificationId) =>
  wrap(() =>
    axios.post(
      `${Config.apiBaseurl}/api/v1/data-quality/verification/${verificationId}/archive`,
      {},
      buildAxiosConfig(),
    ),
  );
